import { useInfiniteQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContacts } from 'services/ContactService'
import { Contacts } from 'types/contacts'

interface ContactsInfiniteQueryProps {
  searchTerm?: string
  contactIds?: string[]
}

export const useContactsInfiniteQuery = ({
  searchTerm = '',
  contactIds = [],
}: ContactsInfiniteQueryProps) => {
  return useInfiniteQuery({
    queryKey: reactQueryKeys.contactsPayment(searchTerm, contactIds),
    queryFn: ({ pageParam = 0 }) =>
      getContacts({ size: 10, page: pageParam, searchQuery: searchTerm, contactIds }),
    getNextPageParam: (lastPage: Contacts) => {
      return lastPage?.pageable?.pageNumber + 1 < lastPage?.totalPages
        ? lastPage?.pageable.pageNumber + 1
        : undefined
    },
    initialPageParam: 0,
    select: data => {
      const contacts = data?.pages?.flatMap(page => page?.content)
      return contacts
    },
  })
}
